import React from 'react';
import { connect } from 'react-redux';
import { Segment, Header, Icon, Grid, Card, Breadcrumb, Image, Modal, Button, Label, Message, TextArea } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { orderBy as _orderBy } from 'lodash';
import './PlaceBidContainer.less';
import moment from 'moment';

import { getSingleBuyerRequestDetails, getSbrBidsHistory, placeBid } from '../../services/Project';
import TimeCountDown from '../../components/TimeCountDown/TimeCountDown';
import BidHistory from '../../components/BidHistory/BidHistory';
import RequestInfo from '../../components/RequestInfo/RequestInfo';
import PhotoCarousel from '../../components/PhotoCarousel/PhotoCarousel';

import { showNotificationMessage } from '../../store/actions/reactNotification'
import { SUCCESS, ERROR } from '../../constants/NotificationType';
import { priceRegex } from '../../constants/regex';
import { priceDisplay } from '../../helpers/price';
import { withRouter } from 'react-router';

import "react-datetime/css/react-datetime.css";
import DatetimePicker from '../../components/Controls/DatetimePicker/DatetimePicker';
import Formsy, { addValidationRule } from 'formsy-react';
import DGTextbox from '../../components/FormControls/Textbox/DGTextbox';
import DGDateTimePicker from '../../components/FormControls/DateTimePicker/DGDateTimePicker';
import { isValidToBid, requestMoreInfo } from '../../services/Seller';
import DGTextarea from '../../components/FormControls/Textarea/DGTextarea';

addValidationRule('isValidDate', function (values, value, array) {
  
  if(value && typeof value == 'string'){
    return false;
  }
  return true;
});

addValidationRule('isValidBid', function(values, value, compareWithValue){
  //console.log(value);
  const bidPrice = parseFloat(value);
  //console.log(!bidPrice);
  if (!bidPrice) {
    return 'Please enter a quote price.';
  } else if (isNaN(bidPrice)) {
    return 'Please enter a valid quote price.'
  }

  return true;
})
class PlaceBidContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      details: { bid: {}, service: {}, sbr: {}, images: [] },
      openedImageIndex: -1,
      bidsHistory: [],
      bidPrice: 0,
      sellerAvailability : null,
      errorMessage: '',
      contactUsDetails: {},
      isMoreInfoModalOpen: false,
      sellerInfoRequestMessage: ''
    }
    this.sbrId = 0;
  }

  async refreshDetails() {
    const details = await getSingleBuyerRequestDetails(this.sbrId);
    let bidsHistory;
    if (details && details.data && details.data.bid && details.data.bid /*&& details.data.bid.sellerBid*/) {
      bidsHistory = await getSbrBidsHistory(this.sbrId);
    }
    await this.setState({
      details: details && details.data || { bid: {}, service: {}, sbr: {}, images: [] },
      bidsHistory: bidsHistory && bidsHistory.data || []
    });
  }
  async componentDidMount() {
    //this.sbrId = this.props.match.params.requestId;
    this.sbrId = this.props.requestId || this.props.match.params.requestId;

    const validBidResponse = await isValidToBid(this.sbrId);
    if(validBidResponse.resStatus == 200){
      const data = validBidResponse.data;
      if(data === false){
        this.props.history.push(`/`);
      }
    }
    await this.refreshDetails();
  }

  save = () => {
    const { bidPrice, sellerAvailability } = this.state;
    this.setState({errorMessage: ''});
    // this.refs.form.reset();
    
    
    placeBid(this.sbrId, { bidPrice, sellerAvailability: sellerAvailability ? sellerAvailability.format('YYYY-MM-DD HH:mm:ss') : null})
      .then((response) => {
        if (response.resStatus == 200) {
          this.props.showNotificationMessage(SUCCESS, 'Quote placed successfully.');
          //this.props.history.push('/home/dashboard');
          this.props.afterBidPlaced();
        } else if (response.resStatus >= 400) {
          this.props.showNotificationMessage(ERROR, response.message || 'Quote placing failed.');
          this.setState({errorMessage: response.message})
        }
      })
      .catch((e) => {
        console.log(e);
        this.props.showNotificationMessage(ERROR, 'Quote placing failed.');
      });
  }

  handleChange = (e, { name, value }) => {
    this.setState({ bidPrice: value });
  }

  onSellerAvailabilityChange = (dateTime) => {
    this.setState({sellerAvailability: dateTime});
  }

  onRequetInfoSubmit = async () => {
    await requestMoreInfo({
      ...this.state.contactUsDetails,
      Question: this.state.sellerInfoRequestMessage,
      subject: 'More Info Request',
    });
    this.setState({ isMoreInfoModalOpen: false })
  }


  onMoreInfoClick = (e) => {
    e.preventDefault();
    this.setState({
      contactUsDetails: {
        SellerPhone: this.props.currentUser.Seller.cellPhone,
        SellerName: this.props.currentUser.Seller.name,
        SellerEmail: this.props.currentUser.Seller.email,
        ServiceName: this.state.details.service.name,
        serviceID: this.state.details.service.serviceID,
        RequestID: this.sbrId,
      },
      isMoreInfoModalOpen: true
    })
  }

  render() {
    const { details, bidsHistory } = this.state;
    const { bid, service, sbr, images } = details;
    
    return (
      <div className="place-bid-container animated fadeInRight">
        {/*<Segment.Group>
          <Segment size="massive" className="no-radius">
            <Header as="h1">
              <Header.Content>

                Place Bid
              </Header.Content>
            </Header>
          </Segment>
          {/*<Segment size="mini" className="no-radius breadcrumb">
            <Breadcrumb>
              <HomeBCItem history={this.props.history} />
              <Breadcrumb.Divider />
              <Breadcrumb.Section active>Place Bid</Breadcrumb.Section>
            </Breadcrumb>
          </Segment>
        </Segment.Group> */}
        <Grid >
          <Grid.Row>
            <Grid.Column>
              <Form onValidSubmit={this.save} ref="form">
                
                <Grid >
                      <Grid.Row>
                        <Grid.Column computer={16} mobile={16}>
                          <Segment className="place-bid-segment">

                              <Header textAlign="center" className='place-bid-header' >Enter your Quote here</Header>
                            <Grid.Column computer={16} mobile={16}>
                              <Message error content={this.state.errorMessage} visible={this.state.errorMessage.length > 0} />
                            </Grid.Column>
                        <Grid style={{marginBottom: '20px'}}>
                          <Grid.Row>
                           
                            <Grid.Column computer={8} mobile={16}>
                            <DGDateTimePicker
                                name="selleravailability"
                                label="Availability"
                                placeholder= ''
                                validations={{
                                  isValidDate: true
                                }}
                                validationErrors= {{
                                  isValidDate: 'Invalid value'
                                }}
                                onChange={this.onSellerAvailabilityChange}
                              
                              />

                              
                            </Grid.Column>
                             <Grid.Column  className='bid-details-bid-price' computer={8} mobile={16}>
                              <DGTextbox
                                autoComplete="off"
                                name="minPrice"
                                placeholder='$00.00'
                                value={this.state.bidPrice}
                                onChange={this.handleChange}
                                label="Bid Price"
                                validations={{
                                 
                                }}

                              />
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column width={16} textAlign="center">
                            <Button className="button-request-more-info" onClick={this.onMoreInfoClick}>Request More Info</Button>
                            <Button className="button-submit-green" type="submit">Submit Quote</Button>
                              <button onClick={this.onMoreInfoClick} class="large ui primary button more-info-mobile">
                                Unable to quote a price? Request more info
                           </button>
                            </Grid.Column>
                          </Grid.Row>
                         
                        </Grid>
                            
                                {/* <hr className="separator" /> */}
                        {/* <Grid style={{marginTop: '10px'}}>
                                <Grid.Row>
                                  <Grid.Column computer={5} mobile={8} className="content-column">
                                    <p>Service</p>
                                    <div className="value">{service.name || 'N/A'}</div>
                                  </Grid.Column>
                                  <Grid.Column computer={5} mobile={8} className="content-column">
                                  <p>Lowest Price Quoted</p>
                                    <div className="value">{priceDisplay(bid.minBid)}</div>
                                  </Grid.Column>
                                  <Grid.Column computer={5} mobile={8} className="content-column"> */}
                                    {/*<p>Request Expires</p>
                                    <div className="value"><TimeCountDown date={sbr.expiry} /></div>*/}
                                    {/* <p>Requested On</p>
                                    <div className="value">{moment(sbr.initiated).format('MMM DD, YYYY')}</div>
                                  </Grid.Column>
                                  <Grid.Column computer={5} mobile={8} className="content-column">
                                  <p>Request Info</p>
                                    <div className="value">{sbr.quickInfo || null}</div>
                                  </Grid.Column>
                                  <Grid.Column computer={5} mobile={8} className="content-column">
                                  <p>Quote Price:</p>
                                    <div className="value">{service.quoteFormat}: Your bid must be for the entire job. Do not bid an hourly rate.</div>
                                  </Grid.Column>
                                </Grid.Row>
                                
                              </Grid> */}
                          </Segment>

                          <div className="place-bid-segment">
                          <RequestInfo title="Job Details" serviceRequestInfo={sbr.serviceFormData} />
                          </div>
                          </Grid.Column>
                          </Grid.Row>
                        
                        
                      <Grid.Row columns={1}>
                        <Grid.Column width="16">
                        <div className="place-bid-segment">
                          <PhotoCarousel images={images} />
                          </div>
                        </Grid.Column>

                      </Grid.Row>

                      <Grid.Row columns={1}>
                        <Grid.Column width={16}>
                        <div className="place-bid-segment">
                        <BidHistory bidHistory={bidsHistory} userHas2PlaceBid={bid && !bid.sellerBid} />
                        </div>
                         

                        </Grid.Column>

                      </Grid.Row>

                      

                    </Grid>
                  
              </Form>
            </Grid.Column>
          </Grid.Row>
          <Modal size='small' open={this.state.isMoreInfoModalOpen} onClose={() => this.setState({ isMoreInfoModalOpen: false })} centered={false} >
            <Modal.Header style={{ fontSize: '14px' }}>Have questions about this request?</Modal.Header>
            <Modal.Content>
              <Formsy onValidSubmit={this.onRequetInfoSubmit}>
                <DGTextarea
                  name='info-request'
                  validationErrors={{
                    isDefaultRequiredValue: 'Please enter some details that you need about this request'
                  }}
                  onChange={(e, data) => this.setState({ sellerInfoRequestMessage: data.value })}
                  required
                  placeholder='Type any information that you need from customer to place a quote'
                  style={{ minHeight: 100, width: '100%', fontSize: '14px', margin: '1rem', minHeight: '100px', padding: '10px', width: 'calc(100% - 2rem)' }} />
                <Grid padded>
                  <Grid.Column width={16} textAlign='right'>
                    <Button primary size='large' >Submit</Button>
                    <Button size='large' onClick={() => this.setState({ isMoreInfoModalOpen: false })}>Close</Button>
                  </Grid.Column>
                </Grid>
              </Formsy>
            </Modal.Content>

          </Modal>
        </Grid>
      </div>
    )
  }

}

const mapStateToProps = ({
  auth: { currentUser }
}) => {
  return { currentUser };
}

const mapDispatchToProps = {
  showNotificationMessage,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlaceBidContainer));